<ng-container *ngIf="isOffcanvas">
  <ng-template [ngTemplateOutlet]="guidePlayerTemplate" [ngTemplateOutletContext]="{isOffcanvas: true}"></ng-template>

  <div appDragClose [dragThreshold]="100" (dragClose)="closeOffcanvas()">
    <div class="drag-handle">
      <div class="drag-indicator"></div>
    </div>
    <div class="offcanvas-header">
      <h5 id="offcanvasLabel" class="mb-0">{{ getModalTitle() }}</h5>
      <button type="button" class="btn-close no-drag" (click)="closeOffcanvas()"></button>
    </div>
  </div>
  <div class="offcanvas-content">
    <div ngbAutoFocus></div>
    <ng-template [ngTemplateOutlet]="bodyContentTemplate"></ng-template>
  </div>
  <div class="offcanvas-actions d-flex align-items-center w-100">
    <ng-template [ngTemplateOutlet]="actionsContentTemplate"></ng-template>
  </div>
</ng-container>
<ng-container *ngIf="!isOffcanvas">

  <app-modal-player [bodyPaddingTop]="0" [title]="getModalTitle()">

    <div class="modal-top">
      <div class="p-3 pb-0 pt-3">
        <ng-template [ngTemplateOutlet]="guidePlayerTemplate" [ngTemplateOutletContext]="{isOffcanvas: false}"></ng-template>
      </div>
    </div>

    <div class="modal-body-content">

        <ng-template [ngTemplateOutlet]="bodyContentTemplate"></ng-template>

    </div>

    <div class="modal-actions w-100">
      <ng-template [ngTemplateOutlet]="actionsContentTemplate"></ng-template>
    </div>

  </app-modal-player>
</ng-container>

<ng-template #bodyContentTemplate>
  <ng-container *ngIf="success">

    <ng-template [ngTemplateOutlet]="successTemplate"></ng-template>
  </ng-container>

  <div *ngIf="!success" class="form">

    <ng-container *ngIf="!isQuoteRequest()">
      <app-shimmer-view *ngIf="viewStatus==ViewStatus.LOADING" [rows]="3" [viewType]="'form'"></app-shimmer-view>
      <formly-form ngbAutoFocus *ngIf="viewStatus == ViewStatus.READY" [fields]="contactFields" [model]="formModel"
        [form]="contactForm"></formly-form>

      <!-- scope indefinito (es. quote-list-item "Contact"): submit va comunque a /quote/create,
           quindi il blocco per richiesta attiva deve poter apparire anche qui, non solo nello
           stepper di isQuoteRequest(). -->
      <ng-template [ngTemplateOutlet]="activeRequestBannerTemplate"></ng-template>
    </ng-container>

    <div *ngIf="isQuoteRequest()" class="custom-stepper">

      <div [class.d-none]="currentStep !== 1" class="step-content">
        <div class="step-intro mb-3 text-center">
          <span class="intro-text">
            {{ 'quote.exploreSolutions' | translate }}
          </span>
          <div class="intro-subtitle mt-1">
            {{ 'quote.exploreSubtitle' | translate }}
          </div>
        </div>

        <app-shimmer-view *ngIf="viewStatus==ViewStatus.LOADING" [rows]="8" [viewType]="'form'"></app-shimmer-view>

        <ng-container *ngIf="viewStatus == ViewStatus.READY">
          <form [formGroup]="requestInfoForm">
            <formly-form [fields]="requestInfoFields" [model]="formModel" [form]="requestInfoForm"></formly-form>
            <formly-form [fields]="specifyRequestField" [model]="formModel" [form]="requestInfoForm"></formly-form>
          </form>
        </ng-container>
      </div>

      <div *ngIf="currentStep === 2" class="step-content">
        <div class="step-intro mb-3">

          <span class="intro-text">
            {{ 'quote.contactInfoTitle' | translate }}
          </span>
          <div class="intro-subtitle mt-1">
            {{ 'quote.contactInfoSubtitle' | translate }}
          </div>
        </div>

        <formly-form [fields]="contactFields" [model]="formModel" [form]="contactForm"></formly-form>
        <span class="text-small text-muted">
          {{'NB. Dental Tour will never provide your phone number to its affiliates without your explicit consent.'
          | translate}}
        </span>

        <ng-template [ngTemplateOutlet]="activeRequestBannerTemplate"></ng-template>
      </div>

    </div>

  </div>

</ng-template>

<ng-template #activeRequestBannerTemplate>
  <div class="alert alert-danger mt-3" *ngIf="phoneBelongsToClinic" role="alert">
    {{ 'errors.phoneBelongsToClinic' | translate }}
  </div>
  <div class="alert alert-warning mt-3" *ngIf="activeRequestExpiresAt">
    <p class="mb-2">
      {{ 'errors.activeQuoteRequestExists' | translate }}
    </p>
    <p class="mb-2 small">
      {{ 'quote.activeRequestExpiresOn' | translate }}
      <strong>{{ activeRequestExpiresAt | date: 'dd/MM/yyyy':'UTC' }}</strong>
    </p>
    <button
      type="button"
      class="btn btn-sm btn-outline-primary"
      *ngIf="!accessLinkSent"
      (click)="onResendAccessLink()">
      {{ 'quote.resendAccessLink' | translate }}
    </button>
    <p class="mb-0 small text-success" *ngIf="accessLinkSent">
      {{ 'quote.accessLinkSent' | translate }}
    </p>
  </div>
</ng-template>

<ng-template #actionsContentTemplate>
  <ng-container *ngIf="!success">

    <div class="d-flex d-flex align-items-center justify-content-between w-100 gap-2">
      <app-button label="{{'Previous' | translate}}" *ngIf="currentStep > 1" (onClick)="goToPreviousStep()"
                  buttonType="secondary" [outlined]="true" [class.w-100]="isOffcanvas"></app-button>
      <app-button label="{{'Continua' | translate}}" *ngIf="currentStep === 1 && scope!='contact'"
        [class.ms-auto]="!isOffcanvas" [class.w-100]="isOffcanvas" (onClick)="goToNextStep()">
      </app-button>
      <app-button label="{{'Submit' | translate}}" *ngIf="scope=='contact'" [isDisabled]="isSubmitting"
        [class.ms-auto]="!isOffcanvas" [class.w-100]="isOffcanvas" (onClick)="onConfirm()"></app-button>
      <app-button *ngIf="currentStep === 2" class="reset-btn" label="{{'Confirm' | translate}}"
        [isDisabled]="isSubmitting" [class.w-100]="isOffcanvas" (onClick)="onConfirm()">
      </app-button>
    </div>
  </ng-container>
</ng-template>

<ngx-spinner bdColor="rgba(51,51,51,0.8)">
  <span class="spinner-border spinner-border-lg me-2 text-muted-light" role="status" aria-hidden="true"></span>
</ngx-spinner>

<ng-template #successTemplate>
  <div class="d-flex flex-column align-items-center justify-content-center text-center">
    <span class="material-symbols-rounded text-success mb-1" style="font-size: 64px;">
      check_circle
    </span>
    <h3 class="mb-3">{{ 'confirmation.title' | translate }}</h3>
    <p class="lead mb-2" [innerHTML]="'confirmation.message' | translate"></p>
    <p class="text-muted mb-4" [innerHTML]="'confirmation.instructions' | translate"></p>
    <!-- <app-phone-number-verification-text [isVerified]="isVerified" [number]="formModel.phoneNumber"></app-phone-number-verification-text> -->
  </div>
</ng-template>

<ng-template #guidePlayerTemplate let-isOffcanvas="isOffcanvas">
  <div [ngClass]="{'mb-0 guide-player-offcanvas': isOffcanvas, 'mb-3': !isOffcanvas}" class="guide-player-container"  *ngIf="!success">
    <div class="player-wrapper">
      <video #guideVideo class="guide-video" [src]="getGuideVideoUrl()" controls autoplay muted loop>
        <source [src]="getGuideVideoUrl()" type="video/mp4">
        {{ 'Your browser does not support video playback' | translate }}
      </video>
      <div class="player-overlay" *ngIf="!isVideoPlaying">
        <button class="play-btn" (click)="playVideo()">
          <i class="ti ti-player-play-filled"></i>
        </button>
      </div>
    </div>
    <div class="guide-text mt-2 d-flex align-items-center justify-content-center">
      <i class="ti ti-info-circle text-muted me-2"></i>
      <span class="text-muted text-white small">
        {{ getGuideText() | translate }}
      </span>
    </div>
  </div>
</ng-template>

